module.exports = __webpack_public_path__ + "img/lh-logo-white.05bda2e9.svg";